import { UscStoreService } from "../../../services/usc-store/usc-store.service";
import { DataTableAdapter } from "../../../adapters/datatable.adapter";
import { ViewColumnField } from '../../../models/view-config/view-column-field.model';
import { ViewButton } from "../../../models/view-config/view-button.model";
import { ViewImageButton } from "../../../models/view-config/view-image-button.model";

export class UscNoApptDatesDataTableAdapter extends DataTableAdapter {

    uscStoreService: UscStoreService;
    store_team_ID: string;
    public current_store: any;
    public show_loading_icon:boolean = false;

    constructor(view: string, serviceCollection: any, store_team_ID: string) {
        super(view, serviceCollection);
        this.store_team_ID = store_team_ID;
        if (serviceCollection['uscStoreService']) this.uscStoreService = serviceCollection['uscStoreService'];
    }

    public initialize(): void {
        if (this.uscStoreService.isLeader()) {
            this.current_store = this.uscStoreService.getCurrentStoreVisitStore();
        }
        super.initialize();
    }

    public getDetailItems(init_filter_fields: boolean): any {
        var params = { 'SP_STORE_USER_ID': this.current_store.store_user_ID, est: "ST_Search" };
        this.uscStoreService.getData(this.uscStoreService.view_no_appt_dates_table, params).subscribe(
            result => {
                this.data_items = result.items;
                this.processDataItems(this.data_items, init_filter_fields);
                this.is_loading_data = false;
            },
            err => {
                console.log(err);
            }
        );
    }

    getFieldValueStyle(data_item: any, field: ViewColumnField) {
        var fvc = {};
        if (data_item && field) {
            var is_holiday = data_item.viewConditions.find(c => c.name == "is_holiday");
            if (field.key == "label" && is_holiday && is_holiday.result == true) {
                fvc = { "background-color": "yellow" };
            }
        }
        return fvc;
    }

    public getFieldValue(data_item: any, field: ViewColumnField): any {
        if (data_item && field) {
            var field_value = data_item[field.key];
            switch (field.key) {
                case 'sunday':
                case 'monday':
                case 'tuesday':
                case 'wednesday':
                case 'thursday':
                case 'friday':
                case 'saturday':
                    field_value = null;
                    break;
            }
            return field_value;
        }
        return null;
    }

    public isPagingEnabled(): boolean {
        return false;
    }

    public getNoDataMessage(): string {
        return "No Dates Found";
    }

    public processAutoSave() {
        this.updateNoApptDates();
    }

    //Sample: no_appt_date = {"date": "2024-09-01", "label": "Monday, September 01, 2024", "is_holiday": false }
    addNoApptDate(no_appt_date:any):string {
        var bNoApptDateAdded:boolean = false;
        var bDuplicatedDateFound:boolean = false;
        var no_appt_dates:any[] = [];
        var no_appt_date_text = this.calendarService.getDateText(no_appt_date.date, "yyyyMMdd");
        var today_date_text = this.calendarService.getDateText(new Date(), "yyyyMMdd");
        var bNewDateInThePast = parseInt(no_appt_date_text) <= parseInt(today_date_text);
        var bNewDateExceededLimit = parseInt(no_appt_date_text) >= parseInt(today_date_text) + 10000; // +1 year from today is the limit
        if (!bNewDateInThePast && !bNewDateExceededLimit) {
            if (this.data_items.length == 0) {
                no_appt_dates.push(no_appt_date);
            } else {
                // attempt to add/insert the new no_appt_date in front of a existing date with the in no_appt_dates list
                this.data_items.forEach(cur_date => {
                    if (!bNoApptDateAdded) {
                        var cur_date_text = this.calendarService.getDateText(new Date(Date.parse(cur_date.label)), "yyyyMMdd");
                        if (no_appt_date_text == cur_date_text) bDuplicatedDateFound = true;
                        if (!bDuplicatedDateFound && parseInt(no_appt_date_text) < parseInt(cur_date_text)) {
                            no_appt_dates.push(no_appt_date);
                            bNoApptDateAdded = true;
                        } 
                    }
                    no_appt_dates.push(cur_date);
                })
                // if the new no_appt_date was not added, that means no_appt_date is the furthest than any date in the no_appt_dates list, just add it to the end
                if (!bNoApptDateAdded) {
                    no_appt_dates.push(no_appt_date);
                    bNoApptDateAdded = true;
                } 
            }
        }

        // validate
        if (bNewDateInThePast) return "Date already passed";
        else if (bDuplicatedDateFound) return "Date already added";
        else if (bNewDateExceededLimit) return "Future Date limit exceeded"
        // process new data_items and save
        else {
            this.data_items = no_appt_dates;
            this.processDataItems(this.data_items, false);
            this.updateNoApptDates();
        } 
        return "";
    }

    updateNoApptDates() {
        this.show_loading_icon = true;
        var data_items = JSON.parse(JSON.stringify(this.data_items));
        var params = { 'store_user_ID': this.current_store.store_user_ID };
        this.uscStoreService.processActionOnViewItemOnPost(this.uscStoreService.view_no_appt_dates_table, this.current_store.store_user_ID, this.uscStoreService.action_update_no_appt_dates, data_items, params).subscribe(
            result => {
                this.sessionService.log("no appt dates updated");
                this.show_loading_icon = false;
            }
        )
    }

    removeNoApptDate(img_btn: ViewImageButton, item: any, field: ViewColumnField) {
        var no_appt_dates:any[] = [];
        this.data_items.forEach(i => {
            if (i != item) no_appt_dates.push(i);
        })
        this.data_items = no_appt_dates;
        this.processDataItems(this.data_items, false);
        this.updateNoApptDates();
    }

    public onBtnClick(btn: ViewButton, item: any, field: ViewColumnField) {
        console.log("onBtnClick::" + btn.event);
        var img_btn = btn as ViewImageButton;
        switch (btn.event) {
            case "sn_client_action": {
                if (img_btn.action == 'action_usc_remove_date') {
                    this.removeNoApptDate(img_btn, item, field);
                } 
            }
        }
    }
 
    public showLoadingIcon() { return this.show_loading_icon; }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-store-scheduling-setup/usc-no-appt-dates-adapter.ts